export default "__VITE_ASSET__B9UERInz__"